import { render } from "./PayrollHistory.vue?vue&type=template&id=48ecbffc&scoped=true"
import script from "./PayrollHistory.vue?vue&type=script&lang=js"
export * from "./PayrollHistory.vue?vue&type=script&lang=js"

import "./PayrollHistory.vue?vue&type=style&index=0&id=48ecbffc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48ecbffc"]])

export default __exports__